import { HeaderGroup } from 'react-table';

import { Icon } from 'components/Icons';

import * as S from './Head.styles';

type HeadProps = {
  headerGroups: HeaderGroup<{}>[];
  hasSort?: boolean;
};

const defaultProps: Partial<HeadProps> = {
  hasSort: false,
};

export function Head(props: HeadProps): React.ReactElement {
  const { headerGroups, hasSort } = { ...defaultProps, ...props };

  return (
    <S.Head>
      {headerGroups.map((headerGroup) => (
        <S.TR
          {...headerGroup.getHeaderGroupProps()}
          key={headerGroup.getHeaderGroupProps().key}
        >
          {headerGroup.headers.map((column) => (
            <S.TH
              {...column.getHeaderProps(hasSort ? column.getSortByToggleProps() : undefined)}
              key={column.getHeaderProps().key}
            >
              {column.render('Header')}
              <S.SortIcon>
                {column.isSorted && (
                  <Icon name={column.isSortedDesc ? 'FiArrowDown' : 'FiArrowUp'} />
                )}
              </S.SortIcon>
            </S.TH>
          ))}
        </S.TR>
      ))}
    </S.Head>
  );
}
